module.exports = __webpack_public_path__ + "img/colaboration.d43d75ef.png";